<template>
    <div class="reviews">
        <div v-for="page in pages" class="review-item">
            <p class="review-description">
                <span v-if="readonly" class="edited_content"  v-html="page.pagetext">
                </span>
                <inline-editor v-if="!readonly" :editable="page.pagetext" :pageid="page._id" dbentry="pagetext" element="textarea"/>
            </p>
            <strong class="review-title">    
                <span v-if="readonly" class="review-image" :style="'background-image: url('+page.blockimage+')'"></span>
                <span v-else class="review-image" :style="'background-image: url('+page.blockimage+')'" @click.prevent="imageModal = true, clickedid = page._id, selectedblockimage = page.blockimage, getimages()"></span>
                <span v-if="readonly" class="edited_content">
                    {{ page.pagetitle }} 
                </span>
                <inline-editor v-if="!readonly" :editable="page.pagetitle" :pageid="page._id" dbentry="pagetitle" element="normal"/>
            </strong>
            <button v-if="!readonly" class="btn btn-secondary btn-ico review-item-remove" @click.prevent="clickedid = page._id, removeModal = true" ><span class="ico material-icons">delete</span></button>
        </div>
        <item-adder @clicked="getPages()" v-if="!readonly" :websiteid="websiteid" :parentpageid="pageid" placeholdertext="Naam van referentie" linktext="Referentie toevoegen"/>

        <modal v-if="removeModal" @close="removeModal = false" title="Verwijder referentie">
            <form @submit.prevent="removePage(clickedid)">
                <p>Weet je zeker dat je deze referentie wil verwijderen?</p>
                <button class="button" type="submit">Ja, ik weet het zeker</button>
            </form>
        </modal>

        <modal v-if="imageModal" @close="imageModal = false" title="Afbeelding aanpassen">
            <ul class="imageselector">
                <li>
                    <upload-modal @clicked="getimages()" :websiteid="websiteid" thestyle="imageuploadbutton btn btn-primary"><span class="material-icons ico">add_circle</span> Upload</upload-modal>
                </li>
                <li v-for="image in images">
                    <button class="imagethumb" @click.prevent="setblockimage(image.image)" :style="'background-image: url('+ imageroot + image.image.split('uploads/').pop() +')'">
                        <span>{{ image.image }}</span>
                    </button>
                </li>
            </ul>
            <form v-if="!readonly" id="blockimage" @submit.prevent="changeBlockSetting('blockimage', selectedblockimage)">
                <input hidden placeholder="Voer afbeelding in" class="textinput form-control mr-2" type="text" name="field_blockimage" v-model="selectedblockimage">
                <button type="submit" class="btn btn-primary">Opslaan</button>
            </form>
        </modal>
    </div>
</template>

<script>
import ItemAdder from '../app/ItemAdder.vue';
import InlineEditor from '../app/InlineEditor.vue';
import Modal from '../modal/Modal.vue';
import UploadModal from '../modal/UploadModal.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components: {
        ItemAdder,
        InlineEditor,
        Modal,
        UploadModal
    },
    props: {
        pageid: String,
        websiteid: String,
        readonly: Boolean
    },
    data: function() {
        return{
            readonly: false,
            imageModal: false,
            removeModal: false,
            file: '',
            images: [],
            clickedid: '',
            selectedblockimage: '',
            imageroot: process.env.VUE_APP_ROOT_API + '/',
            pages: {}
        }
    },
    methods: {
        getPages(){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+this.pageid)
            .then(response => {
              console.log('pages loaded')
                this.pages = response.data.response
            })
        },
        setblockimage(image){
            this.selectedblockimage = this.imageroot+image.split("uploads/").pop()
        },
        getimages(){

            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/media/'+this.websiteid, requestOptions)
            .then(response => {
                this.images = response.data.response
            })
        },
        changeBlockSetting(thedbentry, thecontent){
            const requestOptions = {
              headers: authHeader()
            }

            const data = {
                websiteid: this.websiteid,
                pageid: this.clickedid,
                dbentry: thedbentry,
                content: thecontent
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
            .then(response => {
                this.getPages()
                if(thedbentry == 'blockalign'){
                    this.content.blockalign = thecontent
                } 
                if (thedbentry == 'blockheight') {
                    this.content.blockheight = thecontent
                }
                if (thedbentry == 'blockfontsize') {
                    this.content.blockfontsize = thecontent
                }
                if (thedbentry == 'blockimage') {
                    this.imageModal = false
                }
            })
        },
        removePage(id){

            const requestOptions = {
              headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+id, requestOptions)
            .then(response => {
                this.removeModal = false
                this.getPages()
            })
        }
    },
    mounted(){
        this.getPages()
    }
}
</script>
